import { render, staticRenderFns } from "./index.vue?vue&type=template&id=dccce95a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dccce95a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wwwroot\\dealer-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dccce95a')) {
      api.createRecord('dccce95a', component.options)
    } else {
      api.reload('dccce95a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=dccce95a&scoped=true&", function () {
      api.rerender('dccce95a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/base/address/index.vue"
export default component.exports